import { User as UserIcon, KeyRound, CreditCard, SlidersHorizontal, LifeBuoy } from 'lucide-react'

/**
 * UX-012 / M7: the avatar menu is the first place a person looks for their
 * account, keys, preferences, help and the way out, so all of them are here —
 * not only at the foot of the Settings page. Paths are the canonical /account/*
 * ones (UX-014), so the menu never goes through a legacy redirect.
 */
export const ACCOUNT_MENU_ITEMS = [
  { to: '/account/settings', label: 'Account', icon: UserIcon },
  { to: '/account/security', label: 'Security & keys', icon: KeyRound },
  { to: '/account/billing', label: 'Billing', icon: CreditCard },
  { to: '/account/preferences', label: 'Preferences', icon: SlidersHorizontal },
  { to: '/support', label: 'Support', icon: LifeBuoy },
] as const

/** UX-059: signing out lands on the sign-in page, not the marketing page. */
export const SIGN_OUT_LANDING = '/login'
